import React from 'react'
import styled from '@emotion/styled'
import dayjs from 'dayjs'
import { Button } from '@mobi/component-library/Base/Buttons'
import { Banner } from '@mobi/component-library/Feedback/Banner'
import { font } from '@mobi/component-library/Foundations'
import { useHostContext } from '../../../Common/HostContext'
import { useBetAccount } from '../../../Hooks'
import {
  DAYS_BEFORE_REVERIFICATION_URGENT_REMINDER,
  DAYS_BEFORE_REVERIFICATION_WARNING_REMINDER,
} from '../Utils'
import { REVERIFICATION_ROOT_ROUTE } from '../Utils/routes'

export const ReverificationBanner: React.FC<{ isDesktop: boolean }> = ({ isDesktop }) => {
  const { data: betAccount } = useBetAccount()
  const { history } = useHostContext()

  if (!betAccount) return null

  const reverificationRemainingDays = dayjs(betAccount.ReverificationDueDate).diff(
    dayjs(),
    'days',
    true
  )

  const onCompleteClick = () => {
    if (isDesktop) {
      window.location.href = `/${REVERIFICATION_ROOT_ROUTE}`
    } else {
      history?.push(REVERIFICATION_ROOT_ROUTE)
    }
  }

  const completeButton = (
    <Button color='secondary_grey' size='sm' onClick={onCompleteClick}>
      Complete
    </Button>
  )

  if (reverificationRemainingDays <= DAYS_BEFORE_REVERIFICATION_URGENT_REMINDER) {
    return (
      <Banner
        type='error'
        text={
          <TextStyled>
            Due to AML legislation, we need to collect additional personal information. Please
            complete this <strong>immediately</strong> to maintain your account.
          </TextStyled>
        }
        button={completeButton}
        hideIcon={true}
        key='reverification-banner'
      />
    )
  }

  if (reverificationRemainingDays <= DAYS_BEFORE_REVERIFICATION_WARNING_REMINDER) {
    return (
      <Banner
        type='warning'
        text={
          <TextStyled>
            Due to AML legislation, we need to collect additional personal information. Please
            complete this by{' '}
            <strong>{dayjs(betAccount.ReverificationDueDate).format('DD/MM/YYYY')}</strong> to
            maintain your account.
          </TextStyled>
        }
        button={completeButton}
        hideIcon={true}
        key='reverification-banner'
      />
    )
  }

  return null
}

const TextStyled = styled.span({
  ...font.size.md,
  fontWeight: font.weight.regular,
  fontFamily: font.family.primary,

  '& > strong': {
    fontWeight: font.weight.bold,
  },
})
